import type { UserWalletsById } from '@infinex/types';
import { getWalletsV2Wallets } from '@infinex/types';
import type { GenericDatasetState } from '@infinex/user';
import { useMappedDataset } from '@infinex/user';

/**
 * Returns wallets for the current user (multi-wallet feature).
 *
 * A wallet contains multiple chain runtime addresses (EVM, Solana, Sui).
 *
 * Hierarchy: RecoveryPhrase → Wallet → ChainRuntimeAddresses
 *
 * @returns Record of wallets keyed by ID
 */
export function useWalletsV2Wallets(): GenericDatasetState<UserWalletsById> {
  return useMappedDataset('walletsV2', getWalletsV2Wallets);
}
